import type { MapInfoWindowItemIconProps } from "./map-info-window-item-icon.type";

import { useReferentialConditionRatingsDefaultColor } from "@/entities/referential/referential-condition-ratings";
import ModelIcon from "@/modules/model-icon";

import "./map-info-window-item-icon.style.less";

const MapInfoWindowItemIcon = ({ marker }: MapInfoWindowItemIconProps) => {
  const { type, chipColor } = marker;
  const assetDefaultColor = useReferentialConditionRatingsDefaultColor();
  const backgroundColor =
    chipColor ?? (type === "asset" ? assetDefaultColor : undefined);

  if (type === "default") return null;

  return (
    <div className="map-info-window-item-icon">
      <ModelIcon model={type} />
      {backgroundColor && (
        <div
          className="map-info-window-item-icon-chip"
          style={{ backgroundColor }}
        />
      )}
    </div>
  );
};

export default MapInfoWindowItemIcon;
